import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./CheckSelectModal.module.css";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import clsx from "clsx";
import ToolTip from "components/tooltip/tooltip";
import { toast } from "react-toastify";

import _ from "lodash";

const AdminCheckSelectModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [true, false];
  const [isMounted, setMounted] = useState(false);
  const [data, setData] = useState([]);
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const buttonText = t("close");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [count, setCount] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const divRef = useRef();
  const {
    request,
    Select,
    Search,
    title,
    headers,
    code,
    multiple = true,
    extraCondition = {},
  } = props;

  const limit = props?.limit || 15;
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      request?.(
        {
          offset: page * limit,
          limit: limit,
          ...searchCondition,
          ...extraCondition,
        },
        (result) => {
          setData(result[code]);
          setCount(result.count);
          setMaxPage(result.count / limit);
          divRef.current.scrollTop = 0;
          setSelected([]);
        }
      );
    }
  }, [isMounted]);
  useEffect(() => {
    if (isMounted) {
      request?.(
        {
          offset: page * limit,
          limit: limit,
          ...searchCondition,
          ...extraCondition,
        },
        (result) => {
          setData(result[code]);
          setCount(result.count);
          setMaxPage(result.count / limit);
          divRef.current.scrollTop = 0;
          setSelected([]);
        }
      );
    }
  }, [page, searchCondition]);
  const onCancelClick = () => {
    modal.current.close();
  };
  const onSaveClick = () => {
    if (selected?.length > 0) {
      props?.onSelect?.(data.filter((datum) => selected.includes(datum.id)));
      modal.current.close();
    } else {
      toast.error("최소 1가지 이상을 선택해야합니다.", { autoClose: 1000 });
    }
  };
  const callback = (condition) => {
    setPage(0);
    setSearchCondition({ ..._.merge(searchCondition, condition) });
  };

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div className={style.wrap}>
        <div className={style.detailContainer} style={{ padding: 20 }}>
          <VerticalFlex flexStart={true} gap={30}>
            <VerticalFlex>
              {(Search || Select) && (
                <FlexChild>
                  <HorizontalFlex>
                    {Select && <Select callback={callback} />}
                    {Search && <Search callback={callback} />}
                  </HorizontalFlex>
                </FlexChild>
              )}
              <HorizontalFlex alignItems="center">
                {multiple ? (
                  <FlexChild width="max-content">
                    <CheckBox
                      onChange={(e) => {
                        if (e.target.checked)
                          setSelected([...data.map((data) => data.id)]);
                        else setSelected([]);
                      }}
                      checked={data?.length === selected?.length}
                    />
                  </FlexChild>
                ) : (
                  <FlexChild width="50px" />
                )}

                <FlexChild width="50px">
                  <P padding="5px">No.</P>
                </FlexChild>
                {headers?.map((header) => (
                  <FlexChild width={header?.width} key={header?.label}>
                    <P padding="5px">{header?.label}</P>
                  </FlexChild>
                ))}
              </HorizontalFlex>
              <div style={{ overflowY: "scroll" }} ref={divRef}>
                <VerticalFlex
                  flexStart
                  height="55vh"
                  justifyContent="flex-start"
                >
                  {data?.map((datum, index) => (
                    <FlexChild height="min-content" width="100%">
                      <HorizontalFlex key={index}>
                        <FlexChild width="max-content">
                          <CheckBox
                            onChange={(e) => {
                              if (multiple) {
                                if (e.target.checked)
                                  setSelected([
                                    ...new Set([...selected, datum.id]),
                                  ]);
                                else
                                  setSelected([
                                    ...selected.filter((f) => f !== datum.id),
                                  ]);
                              } else {
                                if (e.target.checked) setSelected([datum.id]);
                                else setSelected([]);
                              }
                            }}
                            checked={selected.includes(datum.id)}
                          />
                        </FlexChild>
                        <FlexChild width="50px">
                          <P padding="5px" textAlign="center">
                            {page * limit + index + 1}
                          </P>
                        </FlexChild>
                        {headers?.map((header, index) => {
                          const displayValue = header?.Cell
                            ? header?.Cell({
                                index: index,
                                row: datum,
                                cell: datum[header.code],
                              })
                            : datum[header.code];
                          return (
                            <FlexChild
                              width={header?.width}
                              key={`${index}_${header?.label}`}
                            >
                              {header.type === "image" ? (
                                <ToolTip
                                  zIndex={10}
                                  left={"30px"}
                                  title={
                                    <img
                                      style={{
                                        maxWidth: "25vw",
                                        maxHeight: "25vh",
                                        height: "25vh",
                                      }}
                                      src={displayValue}
                                      alt="t"
                                    />
                                  }
                                >
                                  <img
                                    src={displayValue}
                                    alt="t"
                                    height={"30px"}
                                    width={"30px"}
                                  />
                                </ToolTip>
                              ) : (
                                <P padding="5px">{displayValue}</P>
                              )}
                            </FlexChild>
                          );
                        })}
                      </HorizontalFlex>
                    </FlexChild>
                  ))}
                </VerticalFlex>
              </div>
            </VerticalFlex>
            {maxPage > 0 && (
              <HorizontalFlex>
                <FlexChild></FlexChild>
                <HorizontalFlex gap={6}>
                  <Move
                    name="《"
                    onClick={() => setPage(0)}
                    disabled={page === 0}
                  />
                  <Move
                    name="〈"
                    onClick={() =>
                      setPage(Math.max(0, page - 10 - (page % 10)))
                    }
                    disabled={page === 0}
                  />
                  <Page page={page} maxPage={maxPage} setPage={setPage} />
                  <Move
                    name="〉"
                    disabled={page === Math.ceil(maxPage - 1)}
                    onClick={() =>
                      setPage(
                        Math.min(
                          Math.ceil(maxPage - 1),
                          page + 10 - (page % 10)
                        )
                      )
                    }
                  />
                  <Move
                    name="》"
                    disabled={page === Math.ceil(maxPage - 1)}
                    onClick={() => setPage(Math.ceil(maxPage - 1))}
                  />
                </HorizontalFlex>
                <FlexChild></FlexChild>
              </HorizontalFlex>
            )}
            <HorizontalFlex justifyContent="center" gap={10}>
              <FlexChild width="max-content">
                <CustomButton onClick={onCancelClick} text="취소" />
              </FlexChild>
              <FlexChild width="max-content">
                <CustomButton onClick={onSaveClick} text="등록" />
              </FlexChild>
            </HorizontalFlex>
          </VerticalFlex>
        </div>
      </div>
    </ModalBase>
  );
});
const Move = ({ name, onClick, disabled }) => {
  return (
    <FlexChild>
      <button onClick={onClick} disabled={disabled}>
        {name}
      </button>
    </FlexChild>
  );
};
const Page = ({ page, maxPage, setPage }) => {
  const start = page - (page % 10);
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    .map((n) => start + n)
    .filter((n) => n < maxPage)
    .map((n) => (
      <FlexChild>
        <button
          style={{ wordBreak: "keep-all" }}
          className={clsx({ "bg-red": n === page })}
          onClick={() => setPage(n)}
        >
          {n + 1}
        </button>
      </FlexChild>
    ));
};
const CheckBox = ({ onChange, checked }) => {
  return (
    <FlexChild width="50px" flex justifyContent="center" alignItems="center">
      <div style={{ padding: "5px" }}>
        <input
          type="checkbox"
          style={{ display: "block", zoom: "1.5" }}
          onChange={onChange}
          checked={checked}
        />
      </div>
    </FlexChild>
  );
};
export default AdminCheckSelectModal;
